import { useMainStore } from '@/store'; // adjust if needed
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import Dashboard from '../pages/Dashboard.vue';
import { setPageTitle } from '@/composables';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/delivery-box',
    name: 'delivery-box',
    component: () => import('../pages/DeliveryBox.vue'),
  },
  {
    path: '/default-categories',
    name: 'default-categories',
    component: () => import('../pages/DefaultCategories.vue'),
  },
  {
    path: '/resellers-management',
    name: 'resellers-management',
    component: () => import('../pages//ResellersManagement/ResellersManagement.vue'),
  },
  {
    path: '/order-barcode',
    name: 'order-barcode',
    component: () => import('../pages/OrderBarcode.vue'),
  },
  {
    path: '/generate-drawing-sheet',
    name: 'generate-drawing-sheet',
    component: { template: '<div></div>' },
    beforeEnter() {
      window.location.href = '/generate-drawing-sheet/index.html';
    },
  },
  {
    path: '/buying-groups-sales-reps',
    name: 'buying-groups-sales-reps',
    component: () => import('@/pages/BuyingGroupSalesRep.vue')
  },
  {
    path: '/ai-analytics',
    name: 'ai-analytics',
    component: () => import('@/pages/AiAnalyticsReport.vue'),
  },
  {
    path: '/customer-feedback',
    name: 'customer-feedback',
    component: () => import('@/pages/CustomerFeedbackDashboard.vue'),
  },
  {
    
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
  },
  // Must be last: unknown paths render 404 instead of a blank view (#13482).
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/pages/NotFound.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: () => ({ top: 0 }),
  routes,
});

let isUserInitialized = false;

router.beforeEach(async (to, from, next) => {
  const store = useMainStore();
  const queryToken = to.query.access_token as string | undefined;
  const queryRefresh = to.query.refresh_token as string | undefined;
  setPageTitle();

  if (queryToken || queryRefresh) {
    if (queryToken) {
      localStorage.setItem('access_token', queryToken);
    }
    if (typeof queryRefresh === 'string' && queryRefresh.length > 0) {
      localStorage.setItem('refresh_token', queryRefresh);
    }

    const { access_token: _a, refresh_token: _r, ...cleanQuery } = to.query;

    return next({
      path: to.path,
      query: cleanQuery,
      replace: true,
    });
  }

  const token = localStorage.getItem('access_token');

  if (token && !isUserInitialized) {
    try {
      await store.getPermissions();
      await store.getNavigation();
      await store.getCurrentUser();

      isUserInitialized = true;

      // if (!store.permissions.includes('access-new-dashboard')) {
      //   await store.logout();
      //   return;
      // }
    } catch (error) {
      console.error('Error loading user data:', error);
      // await store.logout();
      return;
    }
  }

  next();
});

export default router;
